// extracted by mini-css-extract-plugin
module.exports = {"info-list":"UserInfo_info-list__2hnuy","profile-status":"UserInfo_profile-status__1YRDO"};